import { Button, Tabs } from '@medeloop/medeloop-components-library';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useGetOrganization } from 'src/api/organizations-queries';
import { NavigateBack, TitleSubTitle } from 'src/components';

const BASE_ORGANIZATION_URL = '/account/organizations';

const Skeleton = () => <div className="animate-pulse rounded-md bg-cool-gray-800 h-7 w-full" />;

export function OrganizationDetailsPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { organizationId } = useParams();

  const { data, isLoading } = useGetOrganization(organizationId);

  return (
    <section className="flex flex-col">
      <div className="h-52 bg-dark-subdued-background -mb-10 border-b border-stroke-on-dark-subdued">
        <div className="max-w-right-section mx-auto px-6 xl:px-0">
          <NavigateBack to={BASE_ORGANIZATION_URL} label="Organizations" />
          <div className="flex items-center justify-between h-20">
            <TitleSubTitle
              title={data?.organization?.displayName ?? ''}
              subTitle={data?.organization?.name ?? ''}
              isLoading={isLoading}
            />
            <div className="flex gap-6 items-center">
              <div className="flex border rounded-md border-stroke-on-dark-subdued h-full w-80 p-4">
                <div className="flex gap-1 flex-col items-center justify-center pr-4 border-r border-stroke-on-dark-subdued">
                  {isLoading ? (
                    <div className="w-[80px]">
                      <Skeleton />
                    </div>
                  ) : (
                    <>
                      <span className="text-sm">Creation date</span>
                      <span className="text-content-on-dark-default">
                        {data?.organization.createdAt
                          ? new Date(data.organization.createdAt).toISOString().split('T')[0]
                          : ''}
                      </span>
                    </>
                  )}
                </div>
                <div className="flex gap-1 flex-col items-center justify-center pl-4">
                  {isLoading ? (
                    <div className="w-[150px]">
                      <Skeleton />
                    </div>
                  ) : (
                    <>
                      <span className="text-sm">Organization wide access</span>
                      <span className="text-content-on-dark-default">
                        {data?.organization.orgWideAccess ? 'Enabled' : 'Disabled'}
                      </span>
                    </>
                  )}
                </div>
              </div>
              <div>
                <Button>Invite member</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-right-section w-full mx-auto px-6 xl:px-0">
        <Tabs
          value={location.pathname.split('/').pop()}
          onValueChange={(value) => navigate(`${BASE_ORGANIZATION_URL}/${organizationId}/${value}`)}
        >
          <Tabs.List className="border-b-0">
            <Tabs.Trigger value="organizational-units">
              Organizational units ({data?.organizationalUnits?.length ?? 0})
            </Tabs.Trigger>
            <Tabs.Trigger value="researchers">
              Researchers ({data?.researchers?.length ?? 0})
            </Tabs.Trigger>
            <Tabs.Trigger value="admins">Admins ({data?.admins?.length ?? 0})</Tabs.Trigger>
            <Tabs.Trigger value="studies">Studies ({data?.studies?.length ?? 0})</Tabs.Trigger>
            <Tabs.Trigger value="datasets">
              Datasets ({data?.dataSources?.length ?? 0})
            </Tabs.Trigger>
          </Tabs.List>
          <Tabs.Content value="organizational-units">
            <Outlet />
          </Tabs.Content>
          <Tabs.Content value="researchers">
            <Outlet />
          </Tabs.Content>
          <Tabs.Content value="admins">
            <Outlet />
          </Tabs.Content>
          <Tabs.Content value="studies">
            <Outlet />
          </Tabs.Content>
          <Tabs.Content value="datasets">
            <Outlet />
          </Tabs.Content>
        </Tabs>
      </div>
    </section>
  );
}
